<template>
  <div class="pages-index w-full h-[100vh] bg-lighter">
    <div class="py-32 px-32 w-full max-w-[588px]">
      <img src="/logos/bywe_stacked-logo.svg" class="w-full mb-64">
      <div class="type-headline-2xl mb-16">CHOOSE YOUR REGION:</div>
      <div class="flex type-headline-lg mobOnly:flex-col">
        <a
          href="https://dk.bywe.com/"
          target="_self"
          class="flex desk:mr-32 mobOnly:mb-28 items-center underline"
        >
          <div>
            <img src="/flags/1x1/dk.svg" class="w-32 h-32 rounded-full mr-12">
          </div>
          Danmark
        </a>
        <a
          href="https://bywe.com/no"
          target="_self"
          class="flex desk:mr-32 mobOnly:mb-28 items-center underline"
        >
          <div>
            <img src="/flags/1x1/no.svg" class="w-32 h-32 rounded-full mr-12">
          </div>
          Norge
        </a>
        <a
          href="https://bywe.com/se"
          target="_self"
          class="flex items-center underline"
        >
          <div>
            <img src="/flags/1x1/se.svg" class="w-32 h-32 rounded-full mr-12">
          </div>
          Sverige
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'empty',
});
</script>

<style scoped lang="postcss">
</style>
